import { render, staticRenderFns } from "./middleBanner.vue?vue&type=template&id=4383ce4c&scoped=true&"
import script from "./middleBanner.vue?vue&type=script&lang=js&"
export * from "./middleBanner.vue?vue&type=script&lang=js&"
import style0 from "./middleBanner.vue?vue&type=style&index=0&id=4383ce4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4383ce4c",
  null
  
)

export default component.exports